import actions from './actions'
import deliveryGuide from './metaData/deliveryGuide'
export default {
  state: deliveryGuide,
  actions
}
